import { init as initClientData } from './utils/client-data'

initClientData()
